export default __webpack_public_path__ + "a5bc0d719978dd5f0abfc8c80260911b.svg";